// components/Dialog/index.tsx — DialogContainer composition (kompak, tanpa badan kosong).
import React from 'react';
import type { Dialog } from '../../contexts/DialogContext';
import XIcon from '../icons/XIcon';
import { getDialogIcon, getDialogTypeStyles } from './icons.js';

interface DialogContainerProps {
  dialogs: Dialog[];
}

const DialogContainer: React.FC<DialogContainerProps> = ({ dialogs }) => {
  if (dialogs.length === 0) return null;

  const dialog = dialogs[dialogs.length - 1]; // Show only latest dialog
  const styles = getDialogTypeStyles(dialog.type);

  return (
    <>
      {/* Backdrop — di atas semua modal (termasuk Everpro z-9999) supaya
          konfirmasi global selalu terlihat, bukan tenggelam di belakang */}
      <div className="fixed inset-0 z-[10000] bg-black/60 transition-opacity duration-200" />

      {/* Dialog */}
      <div className="fixed inset-0 z-[10001] flex items-center justify-center p-4">
        <div className="bg-card rounded-xl shadow-2xl max-w-sm w-full border border-border overflow-hidden animate-in fade-in zoom-in-95 duration-200">
          <div className="p-5">
            <div className="flex items-start gap-3">
              <div className="shrink-0">{getDialogIcon(dialog.icon)}</div>
              <div className="flex-1 min-w-0">
                <h3 className="text-[15px] font-bold text-foreground leading-snug">
                  {dialog.title}
                </h3>
                {dialog.description && (
                  <p className="text-[13px] text-muted-foreground leading-relaxed mt-1">
                    {dialog.description}
                  </p>
                )}
              </div>
              <button
                onClick={dialog.onCancel}
                disabled={dialog.isLoading}
                aria-label="Tutup"
                className="shrink-0 -mt-0.5 text-muted-foreground hover:text-foreground disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              >
                <XIcon className="w-4 h-4" />
              </button>
            </div>
            <div className="flex gap-2 mt-4">
              {dialog.secondaryText && (
                <button
                  onClick={dialog.onSecondary}
                  disabled={dialog.isLoading}
                  className="flex-1 px-4 py-2 text-sm font-semibold text-foreground bg-muted hover:bg-muted/80 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {dialog.secondaryText}
                </button>
              )}
              <button
                onClick={dialog.onCancel}
                disabled={dialog.isLoading}
                className="flex-1 px-4 py-2 text-sm font-semibold text-foreground bg-muted hover:bg-muted/80 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {dialog.cancelText || 'Batal'}
              </button>
              <button
                onClick={dialog.onConfirm}
                disabled={dialog.isLoading}
                className={`flex-1 px-4 py-2 text-sm font-semibold rounded-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 ${styles.confirmBtn}`}
              >
                {dialog.isLoading && (
                  <div className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent"></div>
                )}
                {dialog.confirmText || 'Konfirmasi'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DialogContainer;
